/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_TitleInputs */

const en_fc_home_faq_title = /** @type {(inputs: Fc_Home_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft FAQ`)
};

/**
* | output |
* | --- |
* | "FilmCraft FAQ" |
*
* @param {Fc_Home_Faq_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_title = /** @type {((inputs?: Fc_Home_Faq_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_title(inputs)
});
export { fc_home_faq_title as "fc.home.faq.title" }